const interactiveBreadcrumb = () => {
  const breadcrumbs = document.querySelectorAll('[data-interactive-breadcrumb]');

  if(breadcrumbs) {
    breadcrumbs.forEach(breadcrumb => {

      const btn = breadcrumb.querySelector('.c-interactive-breadcrumb__pill');
      const items = breadcrumb.querySelectorAll('.c-interactive-breadcrumb__parent-list__item');
      let breadcrumbWidth = 0;

      btn.addEventListener('click', (e) => {
        breadcrumb.classList.toggle('is-open');
      });

      if(items) {
        items.forEach(item => {
          if(item.offsetWidth > breadcrumbWidth) {
            breadcrumbWidth = item.offsetWidth;
          }
        });

        breadcrumb.style.setProperty('--breadcrumb-min-width', `${breadcrumbWidth}px`)
      }


    })
  }
}

interactiveBreadcrumb();
